import MultipleSessionApi from '@/api/multipleSession'
import router from '@/router'
import {
  ROUTE_NAMES,
} from '@/constant/routes'

const actions = {
  publishNewSessionAction: async (_, payload) => {
    return MultipleSessionApi.publishNewSession(payload)
  },
  getPresentationMasterByPresentationIdAction: async (_, payload) => {
    const resp = await MultipleSessionApi.getPresentationMasterByPresentationId(payload)
    return resp.body
  },
  getListSessionsByPresentationIdAction: async (_, payload) => {
    const resp = await MultipleSessionApi.getListSessionsByPresentationId(payload)
    return resp.body
  },
  getPresentationDetailBySessionAction: async (_, payload) => {
    const res = await MultipleSessionApi.getPresentationDetailBySession(payload)
    res.body.slides = res.body.Slides
    return res
  },
  setSelectedSession: async ({ state }, payload) => {
    state.isRenderedReport = false
    state.selectedSession = payload
    if (payload) {
      if (payload.isRoot) {
        state.selectedSession = null
      }
      router.replace({
        name: ROUTE_NAMES.PRESENTATION_REPORT,
        params: {
          id: payload.presentationId,
        },
      })
    }
    state.isRenderedReport = true
  },
  setDefaultSelectedSession: ({ state }, payload) => {
    state.selectedSession = payload
  },
}

export default actions
